import { useId } from "react";
import classes from "./StarRating.module.css";

const LABELS = ["", "Poor", "Fair", "Good", "Great", "Excellent"];

export default function StarRating({ rating, setRating }) {
  const rawId = useId();
  const gradientId = `star-gold-${rawId.replace(/:/g, "")}`;

  function selectStar(star) {
    setRating(star);
  }

  return (
    <div className={classes.wrap}>
      <div
        className={classes.container}
        role="radiogroup"
        aria-label="Star rating"
      >
        <svg width="0" height="0" aria-hidden="true" className={classes.defs}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#fff4c2" />
              <stop offset="42%" stopColor="#ffd15a" />
              <stop offset="100%" stopColor="#f5a623" />
            </linearGradient>
          </defs>
        </svg>
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = rating >= star;
          return (
            <button
              key={star}
              type="button"
              role="radio"
              aria-checked={rating === star}
              aria-label={`${star} star${star > 1 ? "s" : ""}`}
              className={`${classes.star} ${filled ? classes.starFilled : ""}`}
              onPointerDown={(event) => {
                if (event.button !== 0) return;
                event.preventDefault();
                selectStar(star);
              }}
              onClick={() => selectStar(star)}
            >
              <svg
                className={classes.icon}
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M12 2.2l2.55 5.17 5.7.83-4.12 4.02.97 5.68L12 15.2l-5.1 2.7.97-5.68L3.75 8.2l5.7-.83L12 2.2z"
                  fill={filled ? `url(#${gradientId})` : "none"}
                  stroke={filled ? "#ffe7a3" : "#8b93a7"}
                  strokeWidth="1.2"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          );
        })}
      </div>
      <p className={classes.label} aria-live="polite">
        {LABELS[rating] || ""}
      </p>
    </div>
  );
}
